import React from 'react';
import {RoutingConfiguration} from '../../../app-react/services/routing-configuration/configuration/routing-configuration';
import {PageNotFoundComponent} from '../page-not-found/page-not-found.component';
import {ConfigurationsEditorComponent} from '../../components/configurations-editor/configurations-editor.component';
import {UriPath} from '../../../app-react/services/location/uri-path/uri-path';
import {AddGamesFromSdmComponent} from '../../components/add-games-from-sdm/add-games-from-sdm.component';
import {ConfigsJsonViewerComponent} from '../../components/configs-json-viewer/configs-json-viewer.component';
import {LauncherUrlsBuilderComponent} from '../../components/launcher-urls-builder/launcher-urls-builder.component';
import {AddVendorGamesFromSdmComponent} from "../../components/add-vendor-games-from-sdm/add-vendor-games-from-sdm.component";
import {ORBIT_LOCATION_OVERRIDE_BASE} from '../../../app-react/services/location/location.service';

export const LAUNCHER_BASE_PATH = new UriPath('/launch/888debug');

export function buildLauncherPath(path: UriPath | string): UriPath {
    const overrideBase = localStorage.getItem(ORBIT_LOCATION_OVERRIDE_BASE);
    if(overrideBase) {
        return new UriPath(overrideBase).append(LAUNCHER_BASE_PATH.append(path));

    }
    return LAUNCHER_BASE_PATH.append(path);
}

export const LAUNCHER_RELATIVE_PATHS = {
    ADD_VENDOR_GAMES: '/add-vendor-games',
    ADD_GAMES: '/add-games',
    JSON_VIEW: '/json-view',
    BUILD_URLS: '/build-urls'
};



export const LAUNCHER_ROUTING_CONFIGURATION: RoutingConfiguration = {
  fallbackRoute: {
    render: () => <PageNotFoundComponent/>
  },
  routes: [
      {
          paths: [buildLauncherPath('').toString()],
          exact: true,
          render: () => (<ConfigurationsEditorComponent/>)
      },
      {
          paths: [buildLauncherPath(LAUNCHER_RELATIVE_PATHS.ADD_GAMES).toString()],
          exact: true,
          render: () => (<AddGamesFromSdmComponent/>)
      },
      {
          paths: [buildLauncherPath(LAUNCHER_RELATIVE_PATHS.ADD_VENDOR_GAMES).toString()],
          exact: true,
          render: () => (<AddVendorGamesFromSdmComponent/>)
      },
      {
          paths: [buildLauncherPath(LAUNCHER_RELATIVE_PATHS.JSON_VIEW).toString()],
          exact: true,
          render: () => (<ConfigsJsonViewerComponent/>)
      },
      {
          paths: [buildLauncherPath(LAUNCHER_RELATIVE_PATHS.BUILD_URLS).toString()],
          exact: true,
          render: () => (<LauncherUrlsBuilderComponent/>)
      },
  ]
};